import { makeAutoObservable } from "mobx";
import DataLoading from './DataLoading';
import ScaleManager from "./ScaleManager";
import SequencesManager, { SequencesFile } from "./SequencesManager/SequencesManager";
import Translations from "./Translations"
import Speech from "./SpeechLib/Speech"


// import Sounds from "./Sounds";
import App from "./components/App/App";
export const SCREENS = {
  LOADING: "LOADING",
  QUIZ: "QUIZ"
}


function getUrlVar(name) {
  var url = new URL(window.location.href);
  return url.searchParams.get(name);
}

class AppState {
  debugMode = false
  screen = SCREENS.LOADING

  constructor() {
    makeAutoObservable(this)
    if(getUrlVar("debug") === "1") this.debugMode = true

    ScaleManager.init(1600, 900)

    DataLoading.getAllFiles(window.CONFIG.genericFiles, window.CONFIG.root)
    .then(() => {
      DataLoading
      .getAllFiles(window.CONFIG.genericFiles, window.CONFIG.root)
      .then(() => {
        Translations.init(DataLoading.files.translations)
        // Dialogs.init(DataLoading.files.dialogs)
      })
      .then(() => Speech.waitEngineInit())
      .then(() => Speech.init(DataLoading.files.characters, { }))
      .then(() => Speech.addDialogs(DataLoading.files.dialogs))
      .then(() => Speech.loadAllDialogs([Speech.getCharacter("marieJo")]))
      .then(() => Speech.startCharacterAnim("marieJo"))

      .then(() => this.loadQuiz())

      .catch(err => { console.error(err) })
    })
  }

  loadQuiz() {
    this.screen = SCREENS.LOADING
    DataLoading
    .getAllFiles(window.CONFIG.quizFiles, window.CONFIG.root)
    .then(() => {
      const data = SequencesFile.createFromDataFile("quiz", DataLoading.files.quiz.filter(row => row.show))
      SequencesManager.addFile(data)
      this.screen = SCREENS.QUIZ
    })
  }
}

export default new AppState()
